"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleableContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const common_styled_components_1 = require("../common-styled-components");
const Icons_1 = require("../custom/Icons");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const InnerContent = styled_components_1.default.div `
  padding: ${theme_1.theme.spacing(3)} 0;
`;
const ToggleableContent = ({ buttonTitle, closeText, onClose, onOpen, children, defaultOpen, }) => {
    const [open, setOpen] = (0, react_1.useState)(defaultOpen ?? false);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: (e) => {
                    e.preventDefault();
                    if (open && onClose) {
                        onClose();
                    }
                    if (!open && onOpen) {
                        onOpen();
                    }
                    setOpen(!open);
                }, children: !open ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Icons_1.EditIcon, { color: "white" }), (0, jsx_runtime_1.jsx)("span", { children: buttonTitle })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Icons_1.CloseIcon, { color: "white" }), (0, jsx_runtime_1.jsx)("span", { children: closeText })] })) }), open && (0, jsx_runtime_1.jsx)(InnerContent, { children: children })] }));
};
exports.ToggleableContent = ToggleableContent;
